<p-confirmDialog key="school" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<!--Buttons-->
	<div class="button-body flex">
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

		<!--INSERT CUSTOM BUTTONS HERE-->
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onAdd()">Add</button>
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onRemove()">Remove</button>
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstSchool"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="multiple"
		[(selection)]="SelectedSchools"
		dataKey="SchoolID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<th></th>

				<!--INSERT CUSTOM FILTERS HERE-->

				<!--SchoolNumber-->
				<th>
					<p-columnFilter type="text" field="SchoolNumber" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--SchoolName-->
				<th>
					<p-columnFilter type="text" field="SchoolName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--ActivationBeginDTDesc-->
				<th>
					<!-- <p-columnFilter type="text" field="ActivationBeginDTDesc" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--ActivationEndDTDesc-->
				<th>
					<!-- <p-columnFilter type="text" field="ActivationEndDTDesc" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th>
					<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
				</th>

				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="SchoolNumber">Number<p-sortIcon field="SchoolNumber"></p-sortIcon></th>
				<th pSortableColumn="SchoolName">Name<p-sortIcon field="SchoolName"></p-sortIcon></th>
				<th pSortableColumn="ActivationBeginDT">Activated<p-sortIcon field="ActivationBeginDT"></p-sortIcon></th>
				<th pSortableColumn="ActivationEndDT">Expires<p-sortIcon field="ActivationEndDT"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-School>
			<tr [pSelectableRow]="School">
				<td>
					<p-tableCheckbox [disabled]="IsLoading() == true" [pSelectableRow]="School" [value]="School"></p-tableCheckbox>
				</td>

				<td *ngFor="let col of cols" style="font-weight: bold">
					{{ School[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
